import { matchPath } from "react-router-dom";

export interface IRoute {
  moduleName: string;
  path: string;
}

export const matchRoute = (
  pathname: string,
  routes: IRoute[],
  exact: boolean = true
): boolean => {
  return routes.some(route =>
    matchPath(pathname, { path: route.path, exact, strict: true })
  );
};

export const findRoute = (pathname: string, routes: IRoute[]): IRoute => {
  return routes.find(route =>
    matchPath(pathname, { path: route.path, exact: true, strict: true })
  );
};
